import { Outlet, useNavigate, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, ClipboardList, Wallet } from "lucide-react";

export default function CleanerLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-20 backdrop-blur-xl bg-card/80 border-b border-border">
        <div className="max-w-2xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="SmartHost" className="h-9 w-9 object-contain" />
            <div>
              <p className="font-display font-bold text-foreground leading-none">SmartHost</p>
              <p className="text-[11px] text-muted-foreground">Hi, {user?.name?.split(" ")[0]}</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={handleLogout} data-testid="cleaner-logout">
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
        <nav className="max-w-2xl mx-auto px-4 flex gap-1 pb-2">
          <NavLink
            to="/cleaner"
            end
            data-testid="cleaner-nav-jobs"
            className={({ isActive }) =>
              `flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
                isActive
                  ? "bg-secondary text-secondary-foreground"
                  : "text-muted-foreground hover:bg-muted"
              }`
            }
          >
            <ClipboardList className="h-4 w-4" /> My Jobs
          </NavLink>
          <NavLink
            to="/cleaner/earnings"
            data-testid="cleaner-nav-earnings"
            className={({ isActive }) =>
              `flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
                isActive
                  ? "bg-secondary text-secondary-foreground"
                  : "text-muted-foreground hover:bg-muted"
              }`
            }
          >
            <Wallet className="h-4 w-4" /> Earnings
          </NavLink>
        </nav>
      </header>
      <main className="max-w-2xl mx-auto">
        <Outlet />
      </main>
    </div>
  );
}
